import { UUID } from "../generic/uuid";
import { createWineDtoFromOfferWineModel, WineModel } from "./wine";
import { createImageDtoFromOfferImageModel, ImageModel } from "./image";
import { VintageDto } from "@vini-wine/core-dtos";

export interface VintageModel extends UUID {
  // transform
  year: number;

  // default includes
  bottleImage: ImageModel | null;

  // available includes
  wine?: WineModel;
  labelImage?: ImageModel | null;
}

export const createVintageDtoFromOfferVintageModel = (
  vintage: VintageModel,
): VintageDto => {
  return {
    uuid: vintage.uuid,
    year: vintage.year,
    wine: vintage.wine
      ? createWineDtoFromOfferWineModel(vintage.wine)
      : undefined,
    bottleImage: vintage.bottleImage
      ? createImageDtoFromOfferImageModel(vintage.bottleImage)
      : null,
  };
};
